// extracted by mini-css-extract-plugin
module.exports = {"formItem":"render-number_formItem_2ErDb","label":"render-number_label_2yhhF","labelHeader":"render-number_labelHeader_3ICP7"};